import React from 'react';
import { BsLinkedin } from 'react-icons/bs';
import { FaGithub } from 'react-icons/fa';
import { FaInstagram } from 'react-icons/fa';

const HeaderSocials = () => {
  return (
    <div className="header__socials">
      <a href="https://www.linkedin.com/in/gaurav-singh-18b52024b" target="_blank" rel="noreferrer" ><BsLinkedin /></a>
      <a href="https://github.com/gauravsingh54" target="_blank" rel="noreferrer" ><FaGithub /></a>
      <a href="https://instagram.com/prince.singh_18" target="_blank" rel="noreferrer">
  <FaInstagram />
</a>

    </div>
  )
}

export default HeaderSocials